module.exports = __webpack_public_path__ + "img/xxpt_content18.bead3fc6.png";